export { default } from './PageHeader';



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js